export default function PlusIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12.662'
      height='12.662'
      viewBox='0 0 12.662 12.662'
    >
      <g id='Group_4058' data-name='Group 4058' transform='translate(-1111.669 -1627)'>
        <g id='Group_4056' data-name='Group 4056' transform='translate(1111.669 1633.331)'>
          <g id='Group_2158' data-name='Group 2158'>
            <line
              id='Line_283'
              data-name='Line 283'
              y2='12.662'
              transform='translate(12.662 0) rotate(90)'
              fill='none'
              stroke='#fff'
              strokeWidth='2'
            />
          </g>
        </g>
        <g id='Group_4057' data-name='Group 4057' transform='translate(1118 1627) rotate(90)'>
          <g id='Group_2158-2' data-name='Group 2158'>
            <line
              id='Line_283-2'
              data-name='Line 283'
              y2='12.662'
              transform='translate(12.662 0) rotate(90)'
              fill='none'
              stroke='#fff'
              strokeWidth='2'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
